import { CustomAxiosRequestConfig } from "@xt/xtbase";
import axios from "utils/axios";
// import { getOrigin } from "utils/method";

const URL = "/xt-app/";

// 获取当前人机验证平台类型（2: 极验4.0、3: Google、4: Turnstile）
export function get_captchaCurrentPlatform(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/captcha/current-platform`, config);
}

//滑块验证码初始化接口
export function post_captchaApply(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/captcha/apply?ts=${Date.now()}`, null, config);
}

//滑块验证码分析接口
export function post_captchaValidate(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/captcha/validate`, null, config);
}

//滑块验证码初始化接口v2
export function post_captchaApplyV2(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/captcha/v2/apply?ts=${Date.now()}`, null, config);
}

//滑块验证码分析接口
export function post_captchaValidateV2(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/captcha/v2/validate`, null, config);
}

//获取充提币提示信息
export function getCoinTips(config?) {
  return axios.get(URL + `public/coin-tips-config`, config);
}

//推广渠道-监测
export function post_promotionChannelTrace(config: CustomAxiosRequestConfig) {
  return axios.post(URL + `public/promotion-channel/trace`, null, config);
}
